<template>
  <div id="tools" @mouseover="open" @mouseleave="close">
    <span v-if="member && member.name" class="user-btn">
      <i class="far fa-user-circle"></i>
      {{ member.name }}
    </span>

    <span v-else-if="member && member.email">
      <i class="far fa-user-circle"></i>
      {{ member.email }}
    </span>

    <router-link
      v-else
      to="/login"
      class="user-btn">
      <i class="far fa-user-circle"></i>
      {{ $t('general.login') }}
    </router-link>

    <transition name="fade">
      <div v-if="show" class="dropdown">
        <router-link
          v-for="(item, index) in menus"
          :key="index"
          :to="item.url"
          class="dropdown-item">
          {{ item.title }}
        </router-link>

        <span class="dropdown-item" @click="logout">
          {{ $t('general.logout') }}
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TheTools',

  data() {
    return {
      show: false,
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.state.user.token !== null;
    },

    member() {
      return this.$store.state.user.member;
    },

    menus() {
      return [
        {
          title: this.$t('general.dashboard'),
          url: '/dashboard',
        },
        {
          title: 'Wishlist',
          url: '/dashboard?tab=wishlist',
        },
        // {
        //   title: 'Comparison',
        //   url: '/dashboard?tab=comparison',
        // },
        {
          title: 'Profile',
          url: '/dashboard?tab=profile',
        },
      ];
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('user/logout')
        .then(() => {
          this.show = false;
          this.$router.push('/');
        });
    },

    open() {
      if (!this.isAuthenticated) return;
      this.show = true;
    },

    close() {
      if (!this.isAuthenticated) return;
      setTimeout(() => {
        this.show = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
  #tools {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 2rem;
    height: $header-height;
    width: 10rem;
    background-color: $color-primary;
    color: $white;
    text-align: center;

    .user-btn {
      width: 100%;
      font-weight: 700;
      font-size: 0.875rem;
      text-transform: uppercase;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: $white;

      svg {
        margin-right: 0.5rem;
        height: 1.25rem;
        width: 1.25rem;
        vertical-align: sub;
      }
    }

    .dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      width: 100%;
      background-color: $white;
      border-radius: 0 0 0.5rem 0.5rem;
      box-shadow: 0 0.5rem 0.75rem rgba($black, 0.3);
      overflow: hidden;
      text-align: left;

      .dropdown-item {
        display: block;
        width: 100%;
        padding: 0.5rem 1rem;
        color: $grey-dark;
        font-size: 0.875rem;
        text-decoration: none;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          background-color: $color-primary;
          color: $white;
          font-weight: bold;
        }
      }
    }
  }
</style>
